var React = require('react');

function Send (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.83203 10.5V17.1667C3.83203 17.6087 4.00763 18.0326 4.32019 18.3452C4.63275 18.6577 5.05667 18.8333 5.4987 18.8333H15.4987C15.9407 18.8333 16.3646 18.6577 16.6772 18.3452C16.9898 18.0326 17.1654 17.6087 17.1654 17.1667V10.5","stroke":"#262AC5","strokeWidth":"1.67","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M13.8346 5.49984L10.5013 2.1665L7.16797 5.49984","stroke":"#262AC5","strokeWidth":"1.67","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M10.5 2.1665V12.9998","stroke":"#262AC5","strokeWidth":"1.67","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Send.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = Send;

Send.default = Send;
